import { Container as ContainerBase, Typography, Rating as RatingBase } from '@mui/material'

import { styled } from '@mui/material'
import { matchesDesktop, matchesMobile } from '../../../../helpers/breakpoints'
import theme from '../../../../theme'

export const RatingLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  marginTop: '8px',
  ...theme.typography['Lato Body 1'],
  textAlign: 'center',
  [matchesMobile(theme)]: {
    ...theme.typography['Lato Caption'],
  },
}))

RatingLabel.defaultProps = {
  variant: 'Lato Body 2',
}

export const Container = styled(ContainerBase)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const containerStyles = {
  width: '48px',
  marginLeft: '25px',
  maxWidth: 67,
  [theme.breakpoints.down('md')]: {
    width: '40px',
    marginLeft: '16px',
  },
}

export const Rating = styled(RatingBase)(({ theme }) => {
  return {
    minHeight: '100px',
    margin: 'auto',
    marginTop: '48px',

    [matchesDesktop(theme)]: {
      [`label`]: {
        maxWidth: 84,
      },
    },
  }
})
